/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Session')
    .factory('SessionHandler', ['SessionTimeout', function(SessionTimeout){
        return {
            response: function(response) {
                // ignore requests for HTML templates as they do not restart the session
                if(typeof response.data === 'object') {
                    SessionTimeout.restart();
                }
                return response;
            }
        };
    }]);
 
 
